import { render, staticRenderFns } from "./iconConfirmAddress.vue?vue&type=template&id=85620328&scoped=true"
import script from "./iconConfirmAddress.vue?vue&type=script&lang=js"
export * from "./iconConfirmAddress.vue?vue&type=script&lang=js"
import style0 from "./iconConfirmAddress.vue?vue&type=style&index=0&id=85620328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85620328",
  null
  
)

export default component.exports